import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import Formsy from "formsy-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Spinner } from "../../Shared";
import { TextInput, MySelect } from "../../Shared/Forms";
import { idTypeActions } from "../../IdTypes/actions/idtypes.actions";
import { domainActions } from "../../Domains/actions/domains.actions";

export class CardStatusFilter extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getAllDomains();
    this.getIDTypes();
  }

  getAllDomains = () => {
    this.props.getAllDomains();
  };

  getIDTypes = () => {
    this.props.getIdTypes();
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  createRequestParams = params => {
    let request = { ...params };

    if (request.domainObject && request.idObject) {
      request = {
        domain: request.domainObject.code,
        id: request.idObject.code,
        ...request
      };
      delete request.domainObject;
      delete request.idObject;
      return request;
    }

    return null;
  };

  handleSubmit = data => {
    const requestParams = this.createRequestParams(data);
    if (requestParams) {
      this.props.loadData(requestParams);
    }
  };

  render() {
    const { canSubmit } = this.state;
    const {
      submitting,
      fetchingDomains,
      domainResponse,
      domainError,
      fetchingIdTypes,
      idTypeResponse,
      idTypeError,
      params
    } = this.props;

    const selectedDomain =
      params &&
      domainResponse &&
      domainResponse.modelList.filter(domain => domain.code === params.domain);

    const selectedIdType =
      params &&
      idTypeResponse &&
      idTypeResponse.modelList.filter(idType => idType.code === params.id);

    return (
      <div>
        <Row>
          <Col>
            <Formsy
              ref="cardStatusForm"
              onValidSubmit={this.handleSubmit}
              onValid={this.enableButton}
              onInvalid={this.disableButton}
              noValidate
            >
              <Row>
                <Col sm="3">
                  <div>
                    {fetchingDomains ? (
                      <Alert color="info" className="mt-3">
                        <Spinner message="Fetching domains" />
                      </Alert>
                    ) : (
                      <div>
                        <MySelect
                          name="domainObject"
                          title="Domain"
                          options={
                            domainResponse ? domainResponse.modelList : []
                          }
                          value={
                            params && selectedDomain ? selectedDomain[0] : null
                          }
                          valueKey="code"
                          disabled={submitting}
                          labelKey="code"
                          validating={submitting}
                          innerRef={c => {
                            this.domain = c;
                          }}
                          isClearable={true}
                          required
                        />
                        {!domainResponse && domainError && (
                          <Alert className="mt-3" color="danger">
                            {domainError.message}
                            <div className="text-reight">
                              <Button
                                color="danger"
                                onClick={this.getAllDomains}
                              >
                                Retry
                              </Button>
                            </div>
                          </Alert>
                        )}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm="3">
                  <div>
                    {fetchingIdTypes ? (
                      <Alert className="mt-3" color="info">
                        <Spinner message="Fetching ID types" />
                      </Alert>
                    ) : (
                      <div>
                        <MySelect
                          name="idObject"
                          title="Identification Type"
                          options={
                            idTypeResponse ? idTypeResponse.modelList : []
                          }
                          value={
                            params && selectedIdType ? selectedIdType[0] : null
                          }
                          valueKey="code"
                          disabled={submitting}
                          labelKey="code"
                          validating={submitting}
                          innerRef={c => {
                            this.idType = c;
                          }}
                          isClearable={true}
                          required
                        />
                        {!idTypeResponse && idTypeError && (
                          <Alert className="mt-3" color="danger">
                            {idTypeError.message}
                            <div className="text-reight">
                              <Button color="danger" onClick={this.getIDTypes}>
                                Retry
                              </Button>
                            </div>
                          </Alert>
                        )}
                      </div>
                    )}
                  </div>
                </Col>
                <Col sm="3">
                  <TextInput
                    name="value"
                    value={params && params.value}
                    required
                    disabled={submitting}
                    title="Filter value"
                  />
                </Col>
                <Col sm="3">
                  <Button
                    style={{ marginTop: "1.8rem" }}
                    type="submit"
                    color="primary"
                    disabled={!canSubmit || submitting}
                  >
                    {submitting ? <Spinner /> : "Search"}
                  </Button>
                </Col>
              </Row>
            </Formsy>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    fetching: fetchingDomains,
    fetched: fetchedDomains,
    response: domainResponse,
    error: domainError
  } = state.domains;

  const { fetching: submitting, params } = state.cardStatus;

  const {
    fetching: fetchingIdTypes,
    fetched: fetchedIdTypes,
    response: idTypeResponse,
    error: idTypeError
  } = state.idTypes;

  return {
    submitting,
    fetchingDomains,
    fetchedDomains,
    domainResponse,
    domainError,
    fetchingIdTypes,
    fetchedIdTypes,
    idTypeResponse,
    idTypeError,
    params
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getIdTypes: bindActionCreators(idTypeActions.getAllIdTypes, dispatch),
    getAllDomains: bindActionCreators(domainActions.getAllDomains, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardStatusFilter);
